export class AttributeTablesHelper {
  static readonly EYE_COLORS: string[] = [
    'Light Amber', 'Dark Amber',
    'Light Brown', 'Light Brown', 'Light Brown', 'Light Brown',
    'Dark Brown', 'Dark Brown', 'Dark Brown', 'Dark Brown',
    'Blue Hazel', 'Green Hazel',
    'Light Green', 'Dark Green',
    'Light Blue', 'Dark Blue',
    'Light Gray', 'Dark Gray',
    'Light Purple', 'Dark Purple'
  ];

  static readonly HAIR_COLORS: string[] = [
    'Black', 'Black', 'Black',
    'Dark Brown', 'Dark Brown', 'Dark Brown',
    'Medium Brown', 'Medium Brown', 'Medium Brown',
    'Light Brown', 'Light Brown',
    'Dark Blonde', 'Dark Blonde',
    'Medium Blonde',
    'Reddish Brown', 'Reddish Orange', 'Reddish Blonde',
    'Light Blonde', 'Flaxen', 'White'
  ];

  static readonly HAIR_TYPES: string[] = [
    'Straight', 'Straight', 'Straight', 'Straight', 'Straight',
    'Wavy', 'Wavy', 'Wavy', 'Wavy', 'Wavy',
    'Curly', 'Curly', 'Curly', 'Curly', 'Curly',
    'Kinky', 'Kinky', 'Kinky', 'Kinky', 'Kinky'
  ];

  static readonly HAIR_LENGTHS: string[] = [
    'Bald / Shaved', 'Bald / Shaved',
    'Cropped / Short', 'Cropped / Short', 'Cropped / Short', 'Cropped / Short', 'Cropped / Short',
    'Ear / Chin', 'Ear / Chin', 'Ear / Chin', 'Ear / Chin', 'Ear / Chin',
    'Neck / Shoulder', 'Neck / Shoulder', 'Neck / Shoulder', 'Neck / Shoulder',
    'Middle Back / Lower Back',
    'Hip / Thigh',
    'Knee / Calf',
    'Foot / Ground'
  ];

  static readonly SKIN_COLORS: string[] = [
    'Fair', 'Fair',
    'Rosy', 'Rosy',
    'Golden', 'Golden', 'Golden', 'Golden', 'Golden', 'Golden',
    'Olive', 'Olive', 'Olive', 'Olive', 'Olive', 'Olive',
    'Tan', 'Tan',
    'Dark', 'Dark'
  ];

  static readonly DENTAL_STATUSES: string[] = [
    'Missing Some Teeth', 'Missing Some Teeth', 'Missing Some Teeth',
    'Major Cavities', 'Major Cavities', 'Major Cavities', 'Major Cavities',
    'Minor Cavities', 'Minor Cavities', 'Minor Cavities', 'Minor Cavities', 'Minor Cavities', 'Minor Cavities',
    'Heavy Staining', 'Heavy Staining', 'Heavy Staining', 'Heavy Staining',
    'Light Staining', 'Light Staining',
    'Perfect Teeth'
  ];

  static readonly IDENTIFYING_QUALITIES: string[] = [
    'Unique Speech Pattern',
    'Distinguishing Body Mark',
    'Nervous Habit',
    'Abnormal Gait',
    'Specific Intolerance',
    'Unusual Physiology'
  ];

  static readonly ALIGNMENTS: string[] = [
    'Chaotic', 'Chaotic', 'Chaotic', 'Chaotic',
    'Neutral', 'Neutral', 'Neutral', 'Neutral', 'Neutral', 'Neutral',
    'Neutral', 'Neutral', 'Neutral', 'Neutral', 'Neutral', 'Neutral',
    'Lawful', 'Lawful', 'Lawful', 'Lawful'
  ];

  static readonly DOMAINS: string[] = [
    'Air', 'Earth', 'Fire', 'Water', 'Life', 'Death',
    'Chaos', 'Law', 'Luck', 'Nether', 'Aether', 'Fate',
    'Light', 'Darkness', 'Illusion', 'Nature', 'Aberrance',
    'Truth', 'Creation', 'Destruction'
  ];

  static readonly EDICTS: string[] = [
    'Chronicle / Observe', 'Purify / Restore', 'Grow / Nurture',
    'Free / Reverse', 'Balance / Transform', 'Disperse / Wander',
    'Collect / Catalog', 'Defend / Protect', 'Mend / Abet',
    'Tutor / Guide', 'Sustain / Prepare', 'Inquire / Hypothecate',
    'Forgive / Endure', 'Assure / Calm', 'Serve / Consecrate',
    'Distill / Infer', 'Labor / Persevere', 'Chasten / Restrain',
    'Gentrify / Bestow', 'Prosper / Flourish'
  ];

  static readonly ANATHEMAS: string[] = [
    'Hatred / Malice', 'Revenge / Wrath', 'Lust / Temptation',
    'Avarice / Envy', 'Defiance / Scission', 'Deception / Lies',
    'Languor / Inertia', 'Nihilism / Oblivion', 'Zeal / Ardor',
    'Obloquy / Calumny', 'Bias / Iniquity', 'Trifle / Sophistry',
    'Apathy / Indifference', 'Gluttony / Excess', 'Lucre / Pelf',
    'Opression / Slavery', 'Desecration / Infamy', 'Ego / Pride',
    'Hypocrisy / Sanctimony', 'Presumption / Impertinence'
  ];

  static readonly TITLES: string[] = [
    ' the Jocund', ' the Pure', ' the Wise', ' the White',
    ' the Gray', ' the Black', ' the Steadfast', ' the Nimble',
    ' the Brave', ' the Lion', ' the Fox', ' the Bear',
    ' the Swift', ' the Just', ' the Bold', ' the Boar',
    ' the Bat', ' the Wolf', ' the Potent', ' the Auspicious'
  ];

  static readonly MAGIC_USER_SPELLS: string[] = [
    'Charm Person', 'Detect Magic', 'Hold Portal', 'Light',
    'Protection from Evil', 'Read Languages', 'Read Magic', 'Sleep'
  ];

  static readonly MAGIC_USER_SPELLS_BY_LEVEL: string[][] = [
    [],
    ['Charm Person', 'Detect Magic', 'Hold Portal', 'Light', 'Protection from Evil', 'Read Languages', 'Read Magic', 'Sleep'],
    ['Continual Light', 'Detect Evil', 'Detect Invisible', 'ESP', 'Invisibility', 'Knock', 'Levitate', 'Locate Object',
      'Phantasmal Forces', 'Wizard Lock'],
    ['Clairaudience', 'Clairvoyance', 'Dispel Magic', 'Fire Ball', 'Fly', 'Haste', 'Hold Person', 'Infravision',
      'Invisibility 10\' Radius', 'Lightning Bolt', 'Protection from Evil 10\' Radius', 'Protection from Normal Missiles',
      'Slow', 'Water Breathing'],
    ['Charm Monster', 'Confusion', 'Dimension Door', 'Growth of Plants', 'Hallucinatory Terrain', 'Massmorph',
      'Polymorph Others', 'Polymorph Self', 'Remove Curse', 'Wall of Fire', 'Wall of Ice', 'Wizard Eye'],
    ['Animate Dead', 'Cloudkill', 'Conjure Elemental', 'Contact Higher Plane', 'Feeblemind', 'Growth of Animals',
      'Hold Monster', 'Magic Jar', 'Pass-Wall', 'Telekinesis', 'Teleport', 'Transmute Rock to Mud', 'Wall of Iron', 'Wall of Stone'],
    ['Anti-Magic Shell', 'Control Weather', 'Death Spell', 'Disintegrate', 'Geas', 'Invisible Stalker', 'Lower Water',
      'Move Earth', 'Part Water', 'Projected Image', 'Reincarnation', 'Stone to Flesh'],
  ];

  static readonly PROFESSIONS: string[] = [
    'Ackerman', 'Agister', 'Animal Handler', 'Animal Handler', 'Animal Handler',
    'Animal Trainer', 'Apothecary', 'Archaeologist', 'Arkwright', 'Armorer',
    'Artisan', 'Artisan', 'Artist', 'Astrologer', 'Augur',
    'Baker', 'Baker', 'Baker', 'Banker', 'Barber - Dentist',
    'Barber - Surgeon', 'Bargeman', 'Barkeeper', 'Basketman', 'Basketman',
    'Bazaar Merchant', 'Beekeeper', 'Beggar', 'Beggar', 'Blacksmith',
    'Bladesmith', 'Blender (Masonry)', 'Blender (Masonry)', 'Blender (Masonry)', 'Blender (Masonry)',
    'Block Maker / Printer', 'Blower', 'Boatman', 'Bonecarver', 'Boniface (Social)',
    'Bookkeeper', 'Bootmaker', 'Bootmaker', 'Bottler', 'Bowyer',
    'Braider', 'Braider', 'Braider', 'Brazier', 'Brewer',
    'Bricklayer', 'Bricklayer', 'Bricklayer', 'Brightsmith', 'Brogger',
    'Broommaker', 'Buffoon', 'Burler', 'Butcher', 'Butler',
    'Cad (Livery)', 'Candlemaker', 'Candlemaker', 'Candlemaker', 'Caravan Guide',
    'Carder', 'Carpenter', 'Carpenter', 'Carter', 'Carter',
    'Carter', 'Cartographer', 'Cartwright', 'Carver', 'Chambermaid',
    'Chandler', 'Charcoal Burner', 'Charlatan', 'Chinglor', 'Chippy',
    'Clerk', 'Clothier', 'Coachman', 'Cobbler', 'Colporteur',
    'Combmaker', 'Constable', 'Construction Laborer', 'Construction Laborer', 'Cook',
    'Cooper', 'Coppersmith', 'Cordwainer', 'Cordwainer', 'Costermonger',
    'Costermonger', 'Cottager (Unskilled Labor)', 'Cottager (Unskilled Labor)', 'Cottager (Unskilled Labor)', 'Craft Guildsman',
    'Crier', 'Dairyman', 'Dairyman', 'Dancer', 'Diplomat',
    'Disher', 'Ditcher', 'Ditcher', 'Ditcher', 'Ditcher',
    'Dog Breaker', 'Dog Leech (Veterinary)', 'Dowser', 'Draper', 'Driver',
    'Drover', 'Drover', 'Duffer', 'Dyer', 'Ellerman',
    'Engraver', 'Estafette', 'Ewerer', 'Executioner', 'Factor',
    'Falconer', 'Farmer', 'Farmer', 'Farmer', 'Farmer',
    'Farrier', 'Fellmonger', 'Ferryman', 'Fisherman', 'Fisherman',
    'Fletcher', 'Fletcher', 'Forester', 'Fower', 'Fowler',
    'Fripperer', 'Frontiersman', 'Fulker', 'Furbisher', 'Furner',
    'Furnituremaker', 'Furnituremaker', 'Furrier', 'Furrier', 'Furrier',
    'Gamester', 'Gardener', 'Gentleman', 'Geometer', 'Glasswright',
    'Glazier', 'Goldsmith', 'Gong Farmer / Nightman', 'Gong Farmer / Nightman', 'Gong Farmer / Nightman',
    'Goose Herd', 'Goose Herd', 'Government Worker (Local)', 'Gravedigger', 'Graveyard Keeper',
    'Groom', 'Guardsman', 'Guardsman', 'Guide', 'Guild Worker',
    'Gypsy', 'Haberdasher', 'Hacker (Agriculture)', 'Hacker (Agriculture)', 'Harlot',
    'Harlot', 'Hatcheler', 'Hatter', 'Hawker', 'Hawker',
    'Hayward / Hedge Warden', 'Healer / Curer', 'Herbalist', 'Herdsman', 'Herdsman',
    'Herdsman', 'Herdsman', 'Hewer', 'Hiller', 'Hind',
    'Hind', 'Hind', 'Hoggard', 'Horse Leech (Veterinary)', 'Hostler',
    'Hunter', 'Hurdler', 'Impresario', 'Innkeeper', 'Jailer',
    'Janitor', 'Jester / Fool', 'Jeweler', 'Jiggerman', 'Jobmaster',
    'Joiner', 'Juggler / Acrobat', 'Kennel Keeper', 'Knocker Upper', 'Laborer (Unskilled Labor)',
    'Laborer (Unskilled Labor)', 'Laborer (Unskilled Labor)', 'Laborer (Unskilled Labor)', 'Lapidary', 'Leatherworker',
    'Leatherworker', 'Leatherworker', 'Lighthouse Keeper', 'Litster', 'Locksmith',
    'Logger', 'Lorimer', 'Lumberyard Worker', 'Lumberyard Worker', 'Madame / Pimp (Procurer)',
    'Manciple', 'Mason', 'Mender', 'Mender', 'Mercer',
    'Merchant', 'Merchant', 'Merchant Guildsman', 'Messenger / Herald', 'Midwife',
    'Midwife', 'Midwife', 'Miller', 'Millwright', 'Miner',
    'Minstrel', 'Mole Catcher', 'Mole Catcher', 'Mole Catcher', 'Monastery / Convent Aide',
    'Moneylender', 'Mudlark', 'Mummer / Mime', 'Mystic / Soothsayer', 'Needleman',
    'Needleman', 'Netter', 'Nobleman', 'Nurse / Sitter (Foster)', 'Nurse / Sitter (Foster)',
    'Nurse / Sitter (Foster)', 'Orator / Rhetor', 'Overman', 'Packer', 'Painter',
    'Patternmaker', 'Pauper', 'Pauper', 'Pauper', 'Peasant',
    'Peasant', 'Peasant', 'Peregrinator', 'Perfumer', 'Peruker',
    'Picker', 'Pigman / Swine Herd', 'Player', 'Playwright', 'Ponderator',
    'Porter', 'Potter', 'Potter', 'Puddler', 'Puppeteer',
    'Purveyor', 'Quarrier', 'Quister', 'Rat Catcher', 'Rat Catcher',
    'Rat Catcher', 'Reeve', 'Rigger', 'Roper', 'Roper',
    'Rubbler', 'Saddler', 'Sailor, Boat', 'Sailor, Ship', 'Salter',
    'Sapper', 'Sawyer', 'Sawyer', 'Sawyer', 'Scappler',
    'Scourer', 'Scribe', 'Sculptor', 'Seedsman', 'Seedsman',
    'Serf', 'Serf', 'Serf', 'Servant (Hired)', 'Servant (Indentured)',
    'Servant (Indentured)', 'Shearer', 'Sheargrinder', 'Shepherd', 'Shepherd',
    'Shingler', 'Shipwright', 'Singer', 'Slave', 'Smuggler',
    'Soaper', 'Soldier', 'Spicer', 'Spinner', 'Spinner',
    'Spinner', 'Squire', 'Stablehand', 'Stablehand', 'Stable Keeper',
    'Stationer', 'Stoneworker', 'Storyteller', 'Swain', 'Sweeper',
    'Sweeper', 'Tailor', 'Tanner', 'Tanner', 'Taper Weaver',
    'Tapley', 'Tapster', 'Tavern Keeper', 'Tax Assessor', 'Tax Collector',
    'Textor', 'Thatcher', 'Thatcher', 'Thresher', 'Thresher',
    'Thresher', 'Tiler', 'Tinker', 'Tinsmith', 'Tranqueter',
    'Tranter', 'Trapper', 'Trapper', 'Trapper', 'Trencherman',
    'Truchman', 'Tucker', 'Tumbler', 'Turnspit', 'Turnspit',
    'Turnspit', 'Undertaker', 'Upholder', 'Vagrant', 'Vassal',
    'Vintner', 'Wakeman', 'Wakeman', 'Waller', 'Warrener',
    'Water Carrier', 'Water Carrier', 'Water Carrier', 'Waymaker', 'Wayman',
    'Welldigger', 'Wellmaster', 'Wellwright', 'Wharfman', 'Wheelwright',
    'Whitear', 'Winder', 'Wire Drawer', 'Woolcomber', 'Woolman',
    'Wyrth', 'Wyrth', 'Wyrth', 'Xylographer', 'Yardman',
    'Yardman', 'Yardman', 'Yardman', 'Yearman', 'Zoographer'
  ];

  static readonly PROFESSION_DEFINITIONS: {[key: string]: string} = {
    'Ackerman': 'a person who utilizes oxen to plough and till fields.',
    'Agister': 'one who is in charge of ponies in a stable.',
    'Animal Handler': 'one who tends and cares for animals.',
    'Animal Trainer': 'one who trains animals for a specific function.',
    'Apothecary': 'one who prepares medicines and remedies.',
    'Archaeologist': 'one who studies the history of a specific race via artifacts and remains.',
    'Arkwright': 'a craftsman who produces wooden chests and coffers (arks).',
    'Armorer': 'a craftsman who produces suits of armor or armored plates.',
    'Artisan': 'a worker in a skilled trade which involves making things by hand.',
    'Artist': 'a person who specifically produces paintings, drawings, or sculptures by hand.',
    'Astrologer': 'a person who uses astrology to predict the future or interpret events.',
    'Augur': 'one who observes physical phenomena, like casting lots, to interpret events.',
    'Baker': 'a person who makes food items in an oven, such as biscuits, bread, and cakes.',
    'Banker': 'one who digs trenches or ditches with earthen banks for land drainage.',
    'Barber - Dentist': 'a person skilled in hair-cutting, styling, shaving, leeching, and dentistry.',
    'Barber - Surgeon': 'one skilled in hair-cutting, styling, shaving, bloodletting, and surgery.',
    'Bargeman': 'one who maintains and operates a barge.',
    'Barkeeper': 'a person employed at a toll gate to collect fees for passage.',
    'Basketman': 'one who makes baskets and furniture from wicker.',
    'Bazaar Merchant': 'one who sells wares amidst other sellers within an open area.',
    'Beekeeper': 'one who keeps and maintains beehives for honey and wax production.',
    'Beggar': 'a person who badgers others for money as their main source of income.',
    'Blacksmith': 'one who makes and repairs iron and steel items by hand.',
    'Bladesmith': 'one who specializes in making swords, daggers, and knives.',
    'Blender (Masonry)': 'a person who mixes mortar for masonry.',
    'Block Maker / Printer': 'one who engraves or arranges wooden blocks used in printing.',
    'Blower': 'a person who operates the bellows for a smith when heating metal.',
    'Boatman': 'one who operates or repairs boats that usually service rivers and canals.',
    'Bonecarver': 'a person who engraves and carves items out of bone.',
    'Boniface (Social)': 'one who goes around doing good deeds for others in need.',
    'Bookkeeper': 'a person who looks after transactional accounts for a business.',
    'Bootmaker': 'one who specifically makes and repairs boots.',
    'Bottler': 'a person who makes leather containers for holding liquids.',
    'Bowyer': 'one who makes and sells archers’ bows.',
    'Braider': 'a person who makes cord out of thread or braided leather.',
    'Brazier': 'a craftsman who makes items out of brass.',
    'Brewer': 'a person who makes ale or beer.',
    'Bricklayer': 'one who builds structures out of bricks or rectangular stones.',
    'Brightsmith': 'a person who makes items from semi-precious metals.',
    'Brogger': 'one who buys, sells, and trades wool.',
    'Broommaker': 'a person who makes and sells brooms.',
    'Buffoon': 'one who is a professional comic orator or actor.',
    'Burler': 'a person who inspects the quality of clothing.',
    'Butcher': 'one who cuts and divides meat for sale.',
    'Butler': 'the chief servant in a house or estate.',
    'Cad (Livery)': 'a person employed to feed and water horses at transit stops.',
    'Candlemaker': 'one who makes and sells candles.',
    'Caravan Guide': 'a person who guides and helps secure caravans during long journeys.',
    'Carder': 'one who disentangles, intermixes, and cleans wool for subsequent processing.',
    'Carpenter': 'a person who makes and repairs wooden structures.',
    'Carter': 'one who carries objects to and from a designated location.',
    'Cartographer': 'a person who draws or produces maps.',
    'Cartwright': 'one who makes and repairs carts or wagons.',
    'Carver': 'a person who professionally carves objects out of various materials.',
    'Chambermaid': 'a servant who attends to bedrooms within a house, estate, or inn.',
    'Chandler': 'a person who manages the provisions for ships, estates, convoys, etc...',
    'Charcoal Burner': 'one who makes charcoal, usually at forestry or lumber sites.',
    'Charlatan': 'a person who sells various remedies of supposed effectiveness.',
    'Chinglor': 'one who makes and installs wooden shingles for use in roofing.',
    'Chippy': 'a carpenter who specializes in ship and large watercraft construction.',
    'Clerk': 'a person who works as a clergyman.',
    'Clothier': 'a craftsman who makes and sells clothing.',
    'Coachman': 'one who professionally drives coaches and wagons.',
    'Cobbler': 'a person who makes and repairs shoes.',
    'Colporteur': 'a traveling religious text and book seller.',
    'Combmaker': 'one who makes and sells brushes or combs for hair.',
    'Constable': 'the governor of a royal castle or manor.',
    'Construction Laborer': 'a general laborer at a construction site who hauls material.',
    'Cook': 'a person who prepares food by heating it, usually by making potage or porridge.',
    'Cooper': 'a craftsman who makes and repairs barrels or casks.',
    'Coppersmith': 'one who makes items out of copper.',
    'Cordwainer': 'a person who works with goat or equine leather.',
    'Costermonger': 'one who sells fruits and vegetables.',
    'Cottager (Unskilled Labor)': 'a person who works various job requiring menial labor.',
    'Craft Guildsman': 'a craftsman and member of a guild representing the same craft.',
    'Crier': 'a town announcer responsible for verbally spreading decrees in public.',
    'Dairyman': 'one who works on a farm that makes and sells various dairy products.',
    'Dancer': 'a person who dances as a service or artform.',
    'Diplomat': 'one who deals with others in a sensitive and effective way, often politically.',
    'Disher': 'a craftsman who makes bowls and various dishware.',
    'Ditcher': 'a person who digs or repairs ditches and trenches.',
    'Dog Breaker': 'a person who trains dogs for specific tasks.',
    'Dog Leech (Veterinary)': 'one who cares for sick and injured dogs.',
    'Dowser': 'an augur who specializes in finding subterranean water sources.',
    'Draper': 'a person who deals in fabrics and needles for sewing.',
    'Driver': 'one who oversees slaves conducting manual labor.',
    'Drover': 'a person who tends sheep and cattle during herd relocation.',
    'Duffer': 'one who peddles cheap goods and wares.',
    'Dyer': 'a person who dyes thread and yarn prior to weaving.',
    'Ellerman': 'one who makes and sells lamp oil.',
    'Engraver': 'an artisan who carves patterns and artwork into objects.',
    'Estafette': 'a person employed as a mounted courier.',
    'Ewerer': 'a servant who provides hand-washing water, cleans linens, and draws baths.',
    'Executioner': 'one who carries out the sentence of death upon the officially condemned.',
    'Factor': 'a person who is employed by merchants to conduct official transactions.',
    'Falconer': 'one who breeds, trains, and hunts with hawks or falcons.',
    'Farmer': 'a steward who farms land on behalf of the landowner.',
    'Farrier': 'a person who shoes horses.',
    'Fellmonger': 'one who removes hair from hides for making leather.',
    'Ferryman': 'a person who maintains and operates a ferry.',
    'Fisherman': 'one who catches and sells fish.',
    'Fletcher': 'a person who makes arrows and quarrels.',
    'Forester': 'one who monitors game and maintains order in a forest.',
    'Fower': 'a person who sweeps and cleans public areas.',
    'Fowler': 'one who catches or keeps birds.',
    'Fripperer': 'a person who specializes in buying and selling old or used clothing.',
    'Frontiersman': 'one who lives on the border between settled and unsettled territory.',
    'Fulker': 'a person who buys and sells used goods.',
    'Furbisher': 'one who fixes, maintains, and polishes armor.',
    'Furner': 'a person who is in charge of the ovens for a baker.',
    'Furnituremaker': 'a maker of equipment for living / work spaces, as in tables and chairs.',
    'Furrier': 'one who treats, makes, and sells furs and fur garments.',
    'Gamester': 'a person who partakes in competitive games for money.',
    'Gardener': 'one who cultivates and maintains flora for harvest and ornamental use.',
    'Gentleman': 'a person of good social position and wealth.',
    'Geometer': 'one who makes a living utilizing their expertise in geometry.',
    'Glasswright': 'a person who makes and repairs items made of glass.',
    'Glazier': 'one who cuts glass for various uses and glazes pottery.',
    'Goldsmith': 'a person who makes gold items for use as currency.',
    'Gong Farmer / Nightman': 'one who removes excrement from privies and cesspits.',
    'Goose Herd': 'a person who herds and tends geese.',
    'Government Worker (Local)': 'a municipal employee who performs bureaucratic duties.',
    'Gravedigger': 'one who digs graves and pits for the interment of bodily remains.',
    'Graveyard Keeper': 'a person who oversees a graveyard and the structures within.',
    'Groom': 'one who cares for and maintains horses.',
    'Guardsman': 'a person that physically ensures the security of a structure or area.',
    'Guide': 'one who is hired to plan and navigate passage to a destination.',
    'Guild Worker': 'a person employed by a guild to perform a specific duty or function.',
    'Gypsy': 'a nomadic individual who lives by itinerant trade and fortune telling.',
    'Haberdasher': 'one who sells men’s furnishings and various goods.',
    'Hacker (Agriculture)': 'a person who makes agrarian tools such as hoes, mattocks, etc...',
    'Harlot': 'one who engages in sexual activity for payment.',
    'Hatcheler': 'a person who combs and cards flax.',
    'Hatter': 'one who makes and sells various functional or fashionable headwear.',
    'Hawker': 'a person who is an itinerant peddler of various goods.',
    'Hayward / Hedge Warden': 'a local official in charge of fences and land enclosures.',
    'Healer / Curer': 'one who makes and sells various remedies for the unwell.',
    'Herbalist': 'a person who documents and deals in various botanicals and herbs.',
    'Herdsman': 'one who owns or keeps a herd of domesticated animals.',
    'Hewer': 'a person who cuts coal, minerals, or stone for extraction from a mine.',
    'Hiller': 'one who creates facades on structures from tile or stone.',
    'Hind': 'a person who labors on a farm.',
    'Hoggard': 'one who breeds, tends, and sells pigs and hogs.',
    'Horse Leech (Veterinary)': 'a person who cares for sick and injured horses.',
    'Hostler': 'one who grooms horses and other stable-kept animals.',
    'Hunter': 'a person who tracks and kills wild game for a living.',
    'Hurdler': 'one who makes fences and hedge enclosures.',
    'Impresario': 'a person who coordinates and finances the display of performing arts.',
    'Innkeeper': 'one who manages an establishment for the accommodation of travelers.',
    'Jailer': 'a person who guards those who have been imprisoned.',
    'Janitor': 'one who assists a porter by cleaning and organizing various areas.',
    'Jester / Fool': 'a person who is hired to entertain others via mockery and humor.',
    'Jeweler': 'one who crafts personal effects from precious and semi-precious materials.',
    'Jiggerman': 'a person who operates a spinning wheel to form the foot of ceramic items.',
    'Jobmaster': 'one who supplies horses and drivers for hired carriages.',
    'Joiner': 'a carpenter who creates interior finishes by joining wood together.',
    'Juggler / Acrobat': 'one who entertains others by performing dexterous or gymnastic feats.',
    'Kennel Keeper': 'a person who is hired to breed, house, and care for canines or felines.',
    'Knocker Upper': 'one who is hired to wake individuals at a specific time of day.',
    'Laborer (Unskilled Labor)': 'a person who engages in menial labor for income.',
    'Lapidary': 'one who carves, shapes, polishes, and engraves gems.',
    'Leatherworker': 'a person who crafts various personal items from leather.',
    'Lighthouse Keeper': 'one who operates a structure that contains a beacon light for ships.',
    'Litster': 'a person who dyes textiles after weaving.',
    'Locksmith': 'one who makes & repairs physical locking mechanisms that require a key.',
    'Logger': 'a person who cuts down trees for timber.',
    'Lorimer': 'one who makes small ironware items for mounts, such as bits and bridle parts.',
    'Lumberyard Worker': 'a person who processes timber to create building materials.',
    'Madame / Pimp (Procurer)': 'one who arranges clients for and manages harlots or gigolos.',
    'Manciple': 'a person who purchases provisions on behalf of an institution or organization.',
    'Mason': 'one who carves and works with stone to create various structures.',
    'Mender': 'a person who repairs articles of clothing and other textiles.',
    'Mercer': 'one who sells fine fabrics and cloth for use in various products.',
    'Merchant': 'a person who sells and deals in a specific type of good or service.',
    'Merchant Guildsman': 'one who represents a specific group of merchants within a guild.',
    'Messenger / Herald': 'a person who delivers official documents and verbal messages.',
    'Midwife': 'one who is experienced in the birthing process and assists during childbirth.',
    'Miller': 'a person who operates a mill for processing grains.',
    'Millwright': 'one who designs, constructs, and maintains milling equipment and mills.',
    'Miner': 'a person who works in a mine which excavates minerals from the local geology.',
    'Minstrel': 'one who sings and recites lyric or epic poetry with a musical accompaniment.',
    'Mole Catcher': 'a person who catches and deals with small burrowing mammalian pests.',
    'Monastery / Convent Aide': 'a laborer at a domicile for those living under religious vows.',
    'Moneylender': 'one who provides monetary loans for interest or favors.',
    'Mudlark': 'a person who cleans and removes debris from sewers, riverbanks, and beaches.',
    'Mummer / Mime': 'a performer who mimics others and conveys emotion using gestures.',
    'Mystic / Soothsayer': 'one who interprets ritualistic outcomes to infer past or future events.',
    'Needleman': 'a person who sews, tailors, and upholsters for a living.',
    'Netter': 'one who makes and sells open-meshed fabric nets for various uses.',
    'Nobleman': 'a person who is a member of a family with high social or political status.',
    'Nurse / Sitter (Foster)': 'one who tends to the needs of newborns and young children.',
    'Orator / Rhetor': 'a performer who writes speeches and conducts philosophical debates.',
    'Outfitter': 'one who sells goods and equipment used for packing items onto draft animals.',
    'Overman': 'a worker who inspects the production quality of mills, mines, or workshops.',
    'Packer': 'a person who prepares and packs goods for preservation within a container.',
    'Painter': 'one who prepares and applies paint, lacquer, or glaze to various surfaces.',
    'Patternmaker': 'a person who designs and weaves patterns into fabric using a loom.',
    'Pauper': 'one who receives government relief or public charity as primary income.',
    'Peasant': 'a poor farmer of low social status who cultivates a small plot of land.',
    'Peregrinator': 'an itinerant worker who travels far and wide in search of opportunity.',
    'Perfumer': 'a person who makes and sells liquid or solid fragrances.',
    'Peruker': 'one who makes and sells artificial hairpieces such as wigs, merkins, and toupees.',
    'Picker': 'one who receives and casts the shuttle of a loom.',
    'Pigman / Swine Herd': 'a person who wrangles and tends pigs and hogs.',
    'Player': 'an occasionally itinerant performer who presents dramatic works for others.',
    'Playwright': 'one who writes and presents dramatic performances for others.',
    'Ponderator': 'a person who inspects weights and measures compared to official regulation.',
    'Porter': 'one who relocates objects to and from a doored or gated entrance of a structure.',
    'Potter': 'a person who makes various ceramic objects which are heat-cured.',
    'Puddler': 'one who works with a watertight exterior coating (puddle) from clay and sand.',
    'Puppeteer': 'a performer who manipulates an inanimate model to entertain others.',
    'Purveyor': 'one who acquires and sells a specific type of specialty good or service.',
    'Quarrier': 'a quarry worker who excavates large mineral blocks from the local geography.',
    'Quister': 'one who whitens (bleaches) various objects via a chemical process or exposure.',
    'Rat Catcher': 'a person who catches and deals with various rodent pests in populous areas.',
    'Reeve': 'an administrator who oversees local adherence to feudal obligation.',
    'Rigger': 'one who works with the ropes, cables, or chains used to support a ship\'s mast.',
    'Roper': 'a person who makes and sells rope woven from various materials.',
    'Rubbler': 'a quarry worker who sorts small stones and other byproducts of excavation.',
    'Saddler': 'one who makes saddles, harnesses, collars, and bridles for various mounts.',
    'Sailor, Boat': 'a person who operates a small watercraft propelled by oars and / or sails.',
    'Sailor, Ship': 'a worker on a large seafaring vessel used to transport goods or conduct war.',
    'Salter': 'one who procures and sells various types of salt.',
    'Sapper': 'a siege engineer who specializes in fortification access via covered trench (sap).',
    'Sawyer': 'one who saws and cuts timber into uniform boards and planks.',
    'Scappler': 'a person who roughly shapes stone prior to being finished by a stoneworker.',
    'Scourer': 'a thief who prowles wealthy areas in search of targets for burglary.',
    'Scribe': 'one who manually replicates documents and tomes by hand.',
    'Sculptor': 'an artisan who makes three-dimensional forms by carving or casting materials.',
    'Seedsman': 'one who deals in seeds for cultivation and agricultural use.',
    'Serf': 'an agricultural laborer under feudal obligation to work on an estate.',
    'Servant (Hired)': 'one who is hired to perform domestic duties or as a personal attendant.',
    'Servant (Indentured)': 'an attendant who yields their personal freedom to work a contract.',
    'Shearer': 'a person who removes and collects fleece from animals for textile use.',
    'Sheargrinder': 'one who sharpens shears, scissors, knives, and other small cutting tools.',
    'Shepherd': 'a person who tends, herds, feeds, and guards a flock of sheep.',
    'Shingler': 'one who uses wooden tiles to construct the roof of a structure or building.',
    'Shipwright': 'a person who designs, constructs, and repairs ships and other watercraft.',
    'Singer': 'a performer who utilizes their voice for the musical entertainment of others.',
    'Slave': 'a person who is the legal property of another and is required to comply.',
    'Smuggler': 'one who illicitly transports goods or individuals somewhere secretly.',
    'Soaper': 'a person who makes and sells colored & perfumed surfactants used for cleaning.',
    'Soldier': 'one who serves in an organized military force equipped for fighting on land.',
    'Spicer': 'a dealer of aromatic or pungent vegetable substances used to flavor food.',
    'Spinner': 'a person who uses a spinning wheel to convert fibers into thread or yarn.',
    'Squire': 'a young noble who attends to a knight before becoming a knight themselves.',
    'Stable Keeper': 'a person who operates a structure for keeping horses or various mounts.',
    'Stablehand': 'one who labors in a structure adapted for keeping horses or various mounts.',
    'Stationer': 'one who makes and sells paper, writing instruments, and journals.',
    'Stoneworker': 'a person who polishes / finishes various stone shapes for masonry use.',
    'Storyteller': 'one who recites oral lore, history, and epic tales.',
    'Swain': 'a high-ranking soldier or knight’s non-noble servant and attendant.',
    'Sweeper': 'a person who brushes and clears debris from roads, passages, and walkways.',
    'Tailor': 'a craftsman who makes, alters, or repairs clothing.',
    'Tanner': 'one who converts hides into leather by soaking them in a tannic acid solution.',
    'Taper Weaver': 'a person who makes candle and lantern wicks.',
    'Tapley': 'one who makes and installs taps into barrels, casks, and kegs of liquid.',
    'Tapster': 'a person who serves beverages to patrons of a tavern or inn.',
    'Tavern Keeper': 'one who operates an establishment that sells ale and other beverages.',
    'Tax Assessor': 'a person who calculates the taxes an individual or establishment owes.',
    'Tax Collector': 'a local official who solicits, receives, and accounts for taxes to be paid.',
    'Textor': 'one who weaves fabrics by hand or with a loom.',
    'Thatcher': 'a person who covers roofs with reeds, straw, or similar material.',
    'Thresher': 'one who separates grain from the husk or straw of cultivated cereal crops.',
    'Tiler': 'a person who installs rectangular slabs of ceramic used to cover a surface.',
    'Tinker': 'an itinerant worker who repairs or mends household items made of metal.',
    'Tinsmith': 'a craftsman who makes various items from tin.',
    'Tranqueter': 'one who makes hoops for barrels, casks, and kegs.',
    'Tranter': 'a horse and cart owner who provides transport services.',
    'Trapper': 'a person who catches wild animals for their pelts.',
    'Trencherman': 'one who prepares food to be served on wooden boards or platters.',
    'Truchman': 'a person who translates a spoken or written foreign language.',
    'Tucker': 'one who cleans and launders clothing for others.',
    'Tumbler': 'a performer who specializes in acrobatic / gymnastic feats.',
    'Turnspit': 'one who rotates a metal or wooden rod used to cook meat over an open fire.',
    'Undertaker': 'a person who prepares dead bodies for burial or cremation.',
    'Upholder': 'one who renovates furniture by installing padding and fabric.',
    'Vagrant': 'a person without a settled home who wanders various locals to beg for alms.',
    'Vassal': 'a holder of land by feudal tenure on condition of homage and allegiance.',
    'Vintner': 'one who makes and sells wine, sherry, or port.',
    'Wakeman': 'a person who patrols and keeps watch of an area at night.',
    'Waller': 'one who designs and builds walls out of stone or brick.',
    'Warrener': 'a person who manages and tends land for breeding small game.',
    'Water Carrier': 'one who gathers, transports, and sells water from a local source.',
    'Waymaker': 'a person who designs and constructs roads and bridges.',
    'Wayman': 'a person who surveys the status of roads, paths, causeways, and bridges.',
    'Welldigger': 'one who creates a borehole to gain access to a subterranean water source.',
    'Wellmaster': 'a person in charge of the safety and maintenance of a well.',
    'Wellwright': 'one who makes and installs the mechanism for retrieving well water.',
    'Wharfman': 'a person who loads and unloads a moored ship on a quay, pier, or dock.',
    'Wheelwright': 'one who makes and repairs wheels for wagons, carriages, and carts.',
    'Whitear': 'a person who cleans hides for further processing into leather.',
    'Winder': 'one who transfers yarn from bobbins onto cheeses or into balls for weaving.',
    'Wire Drawer': 'a person who makes wire by drawing metal through concentric dies.',
    'Woolcomber': 'one who separates cleansed wool into fibers ready for spinning.',
    'Woolman': 'a person who inspects and separates wool into different graded categories.',
    'Wyrth': 'one who engages in routine domestic or manual tasks for income.',
    'Xylographer': 'one who makes the blank wooden blocks used in printing.',
    'Yardman': 'a laborer who works on a farm or agricultural plot of land.',
    'Yearman': 'a contract laborer who works in yearly increments.',
    'Zoographer': 'one who describes, classifies, and catalogs various types of fauna.',
  };
}
